import React, { Component } from 'react';
import { connect } from 'react-redux'
import * as Actions from './redux-actions.js'
import request from 'request'
import { DisappearedLoading } from 'react-loadingg';
import { withRouter } from "react-router-dom";


//import { Link, Route } from 'react-router-dom'
import * as globals from './globals.js'
import * as helpers from './helpers.js'


import ContactBanner from './ContactBanner.jsx'

import './ModernHome.css'



class ContactPage extends Component {
   constructor(props) {
    super(props);
    window.scrollTo(0, 0);

    this.handleClick = this.handleClick.bind(this)
    this.validateData = this.validateData.bind(this)

    this.state = {name: true,
                  email: true,
                  message: true,
                  loading: false}

  }


  validateData() {
     let valid = true
     if (helpers.validate('full_name',this.f_name.value)) {
        this.setState({name: true})
     } else {
        this.setState({name: false})
        valid = false
     }
     if (helpers.validate('mail',this.f_email.value)) {
        this.setState({email: true})
     } else {
        this.setState({email: false})
        valid = false
     }
     if (helpers.validate('full_name',this.f_message.value)) {
        this.setState({message: true})
     } else {
        this.setState({message: false})
        valid = false
     }

    return valid

  }
  
  handleClick() {
  
     if (this.validateData()) {
        
         this.setState({loading: true})
             helpers.postAPI(
              { func: function(resp) {
              //After receiving response from server
              if (resp.status === 'OK') {
                 // Track conversion with timestamp as transaction ID
                 if (typeof window.gtag_report_conversion === 'function') {
                   window.gtag_report_conversion(undefined, 'contact_' + Date.now());
                 }
                 
                 helpers.closeMessage()
                 helpers.alertMessage('Your message was successfully sent. We will contact you soon.', globals.INFO, true, 20000)
                 if (this.f_name) {
                   this.f_name.value = null
                   this.f_company.value = null
                   this.f_email.value = null
                   this.f_message.value = null
                 }
                 this.setState({loading: false})
              } else {
                 helpers.closeMessage()
                 helpers.alertMessage('Failed to send email. Some problems on the server side, try later or contact us on whatsApp.', globals.ERRO, true, 20000)
                 this.setState({loading: false})

              }

          }.bind(this), 
           uri: globals.myAPIurl+"/contact",
           data: {name: this.f_name.value, company: this.f_company.value, email: this.f_email.value, message: this.f_message.value}
         })

     }
  }

  render() {
  

   let content

 
   if (typeof this.props.reduxDictionary === 'undefined') {
       return (<div><DisappearedLoading color="#000000" size="large"/></div>)
     } 
 
   let loading
   console.log('STATUS', this.props.serverReachable)
   if (this.props.serverReachable && this.state.loading === false) {
      loading=null 
    } else { 
      loading='is-loading'
    }

   return ( 
       <div className="modern-home" style={{marginBottom:"5rem"}}>

{/* Hero Section */}
<section className="hero is-fullheight-with-navbar modern-hero-contact">
  <div className="hero-body">
    <div className="container">
      <div className="columns is-vcentered">
        <div className="column is-6">
          <div className="hero-content">
            <h1 className="modern-title">
              Get in <span className="highlight">Touch</span>
            </h1>
            <p className="modern-subtitle">
              Have questions? We're here to help. Reach out to us anytime - we're available 24/7 to assist you with your travel needs.
            </p>
            
            <div className="contact-info-cards">
              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="contact-info-text">
                  <div className="contact-info-label">Phone</div>
                  <a href="tel:+994502284849" className="contact-info-value" onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(undefined, 'phone_' + Date.now())}>+994 50 228 48 49</a>
                </div>
              </div>
              
              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <i className="fab fa-whatsapp"></i>
                </div>
                <div className="contact-info-text">
                  <div className="contact-info-label">WhatsApp</div>
                  <a href="https://wa.me/994502284849" className="contact-info-value" onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(undefined, 'whatsapp_' + Date.now())}>24/7 Available</a>
                </div>
              </div>
              
              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="contact-info-text">
                  <div className="contact-info-label">Email</div>
                  <a href="mailto:info@az-tur.com" className="contact-info-value">info@az-tur.com</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="column is-6">
          <div className="hero-image-container">
            <div className="floating-card">
              <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/baku_1.jpg" alt="Contact Us" className="hero-image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

{/* Contact Form Section */}
<section className="section modern-contact-form-section">
  <div className="container">
    <div className="columns is-centered">
      <div className="column is-8">
        
        <div className="contact-intro">
          <h2 className="section-title">Send Us a Message</h2>
          <div className="contact-description">
            <p style={{margin:"0.5rem"}} dangerouslySetInnerHTML={{__html: helpers.cnt('contact_1')}}></p> 
            <p style={{margin:"0.5rem"}} dangerouslySetInnerHTML={{__html: helpers.cnt('contact_2')}}></p>
            <p style={{margin:"0.5rem"}} dangerouslySetInnerHTML={{__html: helpers.cnt('contact_3')}}></p>
          </div>
        </div>

        <div className="contact-form-card">


          
          <div className="field">
            <label className="label">Name *</label>
            <div className="control has-icons-left">
              <input className={! this.state.name && "input is-danger" || "input"} type="text" placeholder="Your full name" ref={(x)=>this.f_name=x}/>
              <span className="icon is-small is-left">
                <i className="fas fa-user"></i>
              </span>
            </div>
            {! this.state.name && <div className="help is-danger"><b>Please enter your name</b></div> }
          </div>

          <div className="field">
            <label className="label">Company Name</label>
            <div className="control has-icons-left">
              <input className="input" type="text" placeholder="Your company (optional)" ref={(x)=>this.f_company=x}/>
              <span className="icon is-small is-left">
                <i className="fas fa-building"></i>
              </span>
            </div>
          </div>

          <div className="field">
            <label className="label">Email *</label>
            <div className="control has-icons-left">
              <input className={! this.state.email && "input is-danger" || "input"} type="email" placeholder="your@email.com" ref={(x)=>this.f_email=x}/>
              <span className="icon is-small is-left">
                <i className="fas fa-envelope"></i>
              </span>
            </div>
            {! this.state.email && <div className="help is-danger"><b>Please enter a valid email address</b></div> }
          </div>

          <div className="field">
            <label className="label">Message *</label>
            <div className="control">
              <textarea className={! this.state.message && "textarea is-danger" || "textarea"} placeholder="Tell us how we can help you..." rows="6" ref={(x)=>this.f_message=x}></textarea>
            </div>
            {! this.state.message && <div className="help is-danger"><b>Please enter your message</b></div> }
          </div>

          <div className="field centered" style={{marginTop:"2rem"}}>
            <div className="control">
              <button className={"button is-primary is-large modern-cta-btn "+loading} onClick={this.handleClick}>
                <span className="icon"><i className="far fa-paper-plane"></i></span>
                <span>Send Message</span>
              </button>
            </div>
          </div>

        </div>
        
      </div>
    </div>
  </div>
</section>








       </div>
    )

  }
}


const mapStateToProps$ContactPage = function (state) {
   return { reduxDictionary: state.dictionary,
            serverReachable: state.serverStatus }
}

const mapDispatchToProps$ContactPage = function(dispatch) {
  return {
    setValidity: function(valid) { dispatch(Actions.actionSetValidity(valid)) }
  }
}

export default withRouter(connect(mapStateToProps$ContactPage, mapDispatchToProps$ContactPage)(ContactPage))



